import TasksScreen from "@/components/tasks/TasksPage";

export default function TasksPage() {
  return <TasksScreen />;
}
